import { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import type { MaintenanceStory } from "../utils/maintenance";
import { parseMaintenance } from "../utils/maintenance";
import { useCmsCopyStore } from "./useCmsCopyStore";

type MaintenanceHookState = {
  maintenance: MaintenanceStory | undefined;
  isLoadingMaintenance: boolean;
};

export function useMaintenanceStory(): MaintenanceHookState {
  const cmsCopy = useCmsCopyStore(state => state.cmsCopy);
  const isLoadingCmsCopy = useCmsCopyStore(state => state.isLoadingCmsCopy);
  const { formatMessage } = useIntl();

  const [maintenanceStory, setMaintenanceStory] = useState<string | undefined>(undefined);
  const [isLoadingMaintenance, setIsLoadingMaintenance] = useState(true);

  useEffect(() => {
    if (isLoadingCmsCopy || !cmsCopy || !formatMessage) return;

    try {
      const story = formatMessage({ id: "shared.maintenancePage" });
      setMaintenanceStory(story);
    } catch {
      setMaintenanceStory(undefined);
    } finally {
      setIsLoadingMaintenance(false);
    }
  }, [cmsCopy, formatMessage, isLoadingCmsCopy]);

  const maintenance = useMemo(() => {
    if (!maintenanceStory) return undefined;
    return parseMaintenance(maintenanceStory);
  }, [maintenanceStory]);

  return {
    maintenance,
    isLoadingMaintenance,
  };
}
